<template>
    <router-view />
    <v-layout class="rounded rounded-md">
      <TopBar/>
  
      <!-- メニュー -->
      <TopMenu/>

      <!-- メイン -->
      <v-main class="align-center justify-center" style="min-height: 300px;">
        <SportsStore/>
      </v-main>
  
      <!-- フッター -->
      <v-footer app color="primary">
      </v-footer>
    </v-layout>
  </template>
  
  <script>
  import TopBar from '@/components/TopBar.vue'
  import TopMenu from '@/components/TopMenu.vue'
  import SportsStore from '@/components/SportsStore.vue'
  
  export default {
    name: 'App',
    components: {
        TopBar,
        TopMenu,
        SportsStore,
    },
  }
  </script>
  